export default __webpack_public_path__ + "static/media/hht1_song_04.245ba6d0.png";